// extracted by mini-css-extract-plugin
module.exports = {"actionButton":"_55b699c","visible":"_fa3bedd","container":"_5aaed2c","title":"_25daf84","text":"_fbd08db","buttons":"_0cde5ec"};